import { IconButton, Menu, MenuItem } from "@mui/material";
import React, { useState } from "react";
import { useAuth } from "react-oidc-context";
import classes from "./AccountDropdown.module.scss";
import AccountCircle from '@mui/icons-material/AccountCircle';
import customerSpecs from "../../../assets/data/customerSpecs";
import apiService from "../../../services/api_service";

const AccountDropdown = () => {
  const auth = useAuth();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const handleLogout = async () => {
    try {

      const response = await apiService.fetchLogoutApi(
        {
          userName: auth.user.profile['cognito:username'],
          triggerSource: "logout",
        }
      );

      if (response === 'Successfully logout') { // TODO : FIX RESPONSE CHECK 
        const logoutUri = window.location.href.includes("localhost")
          ? "http://localhost:3000"
          : process.env.REACT_APP_URL_LOCATION;

        // Call removeUser before redirecting
        auth.removeUser();
        auth.clearStaleState();
        auth.signoutSilent();

        window.location.href = `${process.env.REACT_APP_COGNITO_AWS_DOMAIN_URL
          }/logout?client_id=${process.env.REACT_APP_COGNITO_AWS_CLIENT_ID
          }&logout_uri=${encodeURIComponent(logoutUri)}`;

        handleMenuClose();

      } else {
        console.error("Failed to fetch data:", response);
      }
    } catch (error) {
      console.error("Error fetching status:", error);
    }

  };

  const getCustomerDetails = () => {
    return auth?.user?.profile["cognito:groups"][0];
  }

  const getCustomerFormattedName = () => {
    return auth?.user?.profile["cognito:groups"][0].replace(/[_-]+/g, ' ')
    .trim()
    .split(/\s+/)
    .map(w => w ? w[0].toUpperCase() + w.slice(1) : '')
    .join('  ');
  }

  return (
    <div className={classes.accountDropdownWrapper}>
      <IconButton onClick={handleMenuOpen} sx={{ p: 0 }}>
        {getCustomerDetails() in customerSpecs ? customerSpecs[getCustomerDetails()] : <AccountCircle fontSize='large' />}
      </IconButton>
      <span style={{ color: 'black', paddingLeft: '8px', textTransform: 'capitalize' }}>
        {getCustomerFormattedName()}
      </span>
      <Menu
        PaperProps={{
          style: {
            width: "150px", // Set your desired width here
          },
        }}
        className={classes.popupMenu}
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <MenuItem onClick={handleLogout}>Logout</MenuItem>
      </Menu>
    </div>
  );
};

export default AccountDropdown;
